import { ILayoutFilter } from '@base/@types/components/Layout/Filters'

export const followUpReabFilter: ILayoutFilter[] = [
  {
    id: 'empresaIds',
    label: 'Empresa',
    type: 'checkbox'
  },
  {
    id: 'empresaSelectIds',
    label: '',
    filterId: 'companies',
    type: 'select',
    isMulti: true
  },
  {
    id: 'tipoCentroIds',
    label: 'Tipo de Centro',
    type: 'checkbox'
  },
  {
    id: 'tipoCentroSelectIds',
    label: '',
    filterId: 'centerTypes',
    type: 'select',
    isMulti: true
  },
  {
    id: 'centroCdLojaIds',
    label: 'Centro (CD/Loja)',
    type: 'checkbox'
  },
  {
    id: 'centroCdLojaSelectIds',
    label: '',
    filterId: 'centers',
    type: 'select',
    isMulti: true
  },
  // {
  //   id: 'gerenteCategoriaIds',
  //   label: 'Gerente de Categoria',
  //   type: 'checkbox'
  // },
  // {
  //   id: 'gerenteCategoriaSelectIds',
  //   label: '',
  //   filterId: 'categoryManagers',
  //   type: 'select',
  //   isMulti: true
  // },
  {
    id: 'gerenteProdutoIds',
    label: 'Gerente de Produto',
    type: 'checkbox'
  },
  {
    id: 'gerenteProdutoSelectIds',
    label: '',
    filterId: 'productManagers',
    type: 'select',
    isMulti: true
  },
  // {
  //   id: 'mundoIds',
  //   label: 'Mundo',
  //   type: 'checkbox'
  // },
  // {
  //   id: 'mundoSelectIds',
  //   label: '',
  //   filterId: 'worlds',
  //   type: 'select',
  //   isMulti: true
  // },
  {
    id: 'categoriaCompactaIds',
    label: 'Categoria Compacta',
    type: 'checkbox'
  },
  {
    id: 'categoriaCompactaSelectIds',
    label: '',
    filterId: 'compactCategories',
    type: 'select',
    isMulti: true
  },
  {
    id: 'subCategoriaIds',
    label: 'Sub Categoria',
    type: 'checkbox'
  },
  {
    id: 'subCategoriaSelectIds',
    label: '',
    filterId: 'subCategories',

    type: 'select',
    isMulti: true
  },
  {
    id: 'purchaseOrderTypesIds',
    label: 'Tipo de Pedido',
    type: 'checkbox'
  },
  {
    id: 'purchaseOrderTypesSelectIds',
    label: '',
    filterId: 'purchaseOrderTypeReab',
    type: 'select',
    isMulti: true
  },
  // {
  //   id: 'pedidosIds',
  //   label: 'Pedidos',
  //   type: 'checkbox'
  // },
  {
    id: 'pedidosSelectIds',
    label: 'Pedidos',
    type: 'select-api-post',
    apiUrl: '/v1/PedidoCompra',
    idsField: 'pedidosIds',
    labelFields: ['descricao'],
    isMulti: true
  },
  {
    id: 'produtoSelectIds',
    label: 'Produto',
    type: 'select-api-post',
    apiUrl: '/v1/Produto/Compras',
    idsField: 'produtosIds',
    isMulti: true
  },
  {
    id: 'periodoIds',
    label: 'Data',
    type: 'checkbox'
  },
  {
    id: 'periodoSelectIds',
    label: '',
    type: 'date-input',
    isMulti: true
  }
]
